import { render, staticRenderFns } from "./CustomersFiltersForm.vue?vue&type=template&id=05ca0954"
import script from "./CustomersFiltersForm.vue?vue&type=script&lang=js"
export * from "./CustomersFiltersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports